import React from 'react'
import $ from 'jquery'
import '../../utility/csrf'
import GlobalBanner from '../../components/globalBanner'
import LinnerDiv from '../../components/lineDiv'
import SubHeader from '../../components/subHeader'
import Note from '../../components/note'
import GuestPPLogInMini from '../../components/guestPPMiniLogIn'
import GuestPPLogIn from '../../components/guestPPLogIn'
import AmountWrapper from '../../components/amountWrapper'
import GuestForm from '../guest/guestForm'
import PayCreditOrDebit from '../../components/payCreditOrDebit'
import RecurringCheckBox from '../../components/recurring-checkbox'
import { i18n } from 'react-i18n'

import { handleLogIn, handleTokenReuse } from '../../utility/helper'

import templateData from '../../utility/getTemplateData'
import appStore from '../../stores/AppStore'
import AppDispatcher from '../../dispatcher/AppDispatcher'
import * as FPT from '../../utility/fpt'

const pxp = templateData.pxp || {};
const showGuestPPLogInExp = pxp.guestPayPalLogIn && pxp.guestPayPalLogIn.experiment || false;

export default React.createClass({

	mixins: [i18n('routes/guest')],

	getInitialState() {
		return {
			hasLogo: templateData.hasLogo,
			subHeaderLabel: templateData.donationName,
			orgName: templateData.charityName,
			donationId: templateData.donationId,
			guestRedirectUrl: templateData.guestRedirectUrl,
			donateDisabled: false,
			showServiceErrors: false,
			errorMesages: [],
			recurringEnabled: templateData.recurringEnabled,
			recurringStatus: false,

			recurringHelpText: '',
			recurringLabel: 'Make this a monthly donation'
		};
	},

	componentDidMount() {
		// Only adding page name, if "fptPageName=landing", in other cases track event will be triggered when template is loaded.
		if (templateData.fptPageName === 'landing') {
			FPT.trackPage('main:donate:wps:guest:guestform', 'main:donate:wps:guest:guestform:web::')
		}

		let donationRecurring = appStore.getDonationRecurring();
		if(donationRecurring === 'checked') this.setState({ recurringStatus: true });

		$('.spinneroverlay').hide();

		handleTokenReuse();

		let self = this

		// Handles serverside errors
		AppDispatcher.register(function(payload) {

			 if (payload.action && (payload.action.actionType === 'UPDATE_SERVER_ERRORS')) {

				let errorMesages = payload.action.item.serverErrors
				let showServiceErrors = errorMesages.length > 0

				self.setState({
					showServiceErrors: showServiceErrors,
					errorMesages: errorMesages
				});

				if (showServiceErrors) {
					let errorEl = $('.service_error_holder:visible')
					$('html, body').animate({
						scrollTop: errorEl.offset() && errorEl.offset().top
					}, 1000);
				}
			 }
		});
	},

	componentWillUnmount() {},

	getFPTDATA() {
		return {
			amount: appStore.getDonationAmount(),
			code: appStore.getDonationCode(),
			symbol: appStore.getDonationSymbol()
		}
	},

	updateConversionSataus(status = false) {
		this.setState({ donateDisabled: status });
	},

	handleLogIn(event) {
		event.preventDefault();
		if (appStore.getDonationAmount()) {
			FPT.trackLinkClickWithData('guestLogIn', this.getFPTDATA())
		}
		handleLogIn()
	},

	handleRecurringChange(status = false) {
		this.setState({ recurringStatus: status });
	},

	render() {
		let errorgeneric = this.i18n('error.generic')
		let recurringStatus = appStore.getDonationRecurring() === 'checked';
		return (
			<div className="donate_wrapper">
				<div className="container">
					{this.state.showServiceErrors ?
						<div className="col-xs-12 col-sm-12 col-md-12 service_error_holder">
							{this.state.errorMesages.map(function(message) {
								return <div className="row" key={message.key}>
											<p className="col-xs-1 col-sm-1 col-md-1"><span className="icon icon-small icon-critical-small" aria-hidden="true"></span></p>
											<p className="col-xs-11 col-sm-11 col-md-11"style={{ paddingLeft: '5px', marginTop: '5px' }}>{message.value}</p>
								</div>;
							})}
						</div> : null}
					<GlobalBanner
						logourl={this.state.logourl}/>
					<SubHeader
						donationId={this.state.donationId}
						orgName={this.state.orgName}
						label={this.state.subHeaderLabel}/>
					<form id="guestForm" noValidate>
						<AmountWrapper conversionStatus={this.updateConversionSataus}/>
						<p className="err_update_amount text-center">{errorgeneric}</p>
						{this.state.recurringEnabled && <RecurringCheckBox
															toolTipText={this.state.recurringHelpText}
															label={this.state.recurringLabel}
															status={this.state.recurringStatus}
															handleChange={this.handleRecurringChange}
															hasRecurringHelp={false}
															showNote={true}/>
						}
						<LinnerDiv />
						{templateData.charityNoteEnabled ? <Note /> : null}
						{showGuestPPLogInExp ?
							<GuestPPLogIn handleLogIn={this.handleLogIn}/> :
							<GuestPPLogInMini handleLogIn={this.handleLogIn}/>
						}
						<PayCreditOrDebit />
						<GuestForm recurringStatus={recurringStatus} donateDisabled={this.state.donateDisabled} />
					</form>
				</div>
			</div>
		)
	}
})



// WEBPACK FOOTER //
// ./pages/guest/guest.js